import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  addIcon: {
    alignItems: 'center',
    border: '1px dashed #6d6e6f',
    borderRadius: '50%',
    display: 'flex',
    fill: '#6d6e6f',
    flexGrow: 0,
    flexShrink: 0,
    justifyContent: 'center',
    height: '33px',
    width: '33px',
    marginRight: theme.spacing(1),
  },
  linkButton: {
    borderRadius: '8px',
    border: '1px solid #d8dde1',
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1.5),
    minWidth: '200px',
    backgroundColor: '#fff',
    transition: 'all 0.2s ease-in-out',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f5f5f5',
      borderColor: '#c4c4c4',
      '& $menuButton': {
        opacity: 1,
      },
    },
  },
  buttonText: {
    color: '#6d6e6f',
    fontWeight: 500,
  },
  linkName: {
    textTransform: 'capitalize',
    color: '#2c2c2c',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth:'90px',
    display:'block',
    overflow: 'hidden',
  },
  menuButton: {
    opacity: 0,
    transition: 'opacity 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  editButton: {
    color: theme.palette.primary.main,
    opacity: 0.9,
    textTransform: 'none',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  deleteButton: {
    opacity: 0.9,
    textTransform: 'none',
    fontWeight: 500,
    color: theme.palette.error.main,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
}));

export { useStyles };
